module.exports = __webpack_public_path__ + "img/custom_plumber02.77aece71.jpg";